module.exports = __webpack_public_path__ + "img/code.8ae269b8.svg";